<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="materials.pkid > 0 ? '检验项编辑':'检验项新建'"
      class="customer-edit"
      width="1000px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="materials"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="14">
          <el-form-item label="编号">
            <el-input
                v-model="materials.no"
                placeholder="编号"
                disabled="disabled"/>
          </el-form-item>
          <el-form-item label="检验类型">
            <el-radio-group v-model="materials.inspectionType">
              <el-radio :label="10">来料检验</el-radio>
              <el-radio :label="20">生产入库检验</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="检验项类型">
            <el-radio-group v-model="materials.itemDataType">
              <el-radio :label="10">值类型</el-radio>
              <el-radio :label="20">图片</el-radio>
              <el-radio :label="30">数据类型</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item
                  label="名称"
                  prop="name">
                <el-input v-model="materials.name" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  label="检验标准"
                  prop="inspectionStandard">
                <el-input v-model="materials.inspectionStandard" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                  v-if="materials.itemDataType===10"
                  label="标准值">
                <el-input v-model="materials.standardValue" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  v-if="materials.itemDataType===10"
                  label="最大值">
                <el-input v-model="materials.maxValue" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                  v-if="materials.itemDataType===10"
                  label="最小值">
                <el-input v-model="materials.minValue" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                  v-if="materials.itemDataType===10"
                  label="单位">
                <el-input v-model="materials.unit" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                  v-if="materials.itemDataType===10"
                  label="检验工具">
                <el-input v-model="materials.inspectionTools" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="materials.itemDataType===20" label="是否上传图片">
            <el-radio-group v-model="materials.uploadPictures">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="检验方式">
            <el-radio-group v-model="materials.inspectionMethod">
              <el-radio :label="0">全检</el-radio>
              <el-radio :label="1">免检</el-radio>
              <el-radio :label="2">抽检</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="检验频率">
            <el-radio-group v-model="materials.inspectionFrequency">
              <el-radio :label="0">年</el-radio>
              <el-radio :label="1">周</el-radio>
              <el-radio :label="2">月</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="vm-separate">
            <el-form-item label="检验站点">
              <el-select v-model="materials.inspectionStation" clearable placeholder="请选择">
                <el-option
                    v-for="item in inspectionStations"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="检验说明">
            <el-input v-model="materials.note" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="上传图片">
            <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"/>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constant from "../../../util/constant";
  export default {
    name:"MaterialGuidCreate",
    components: {},
    data() {
      return {
        constant,
        inspectionPercentages: constant.toSelect(constant.inspectionPercentage),
        inspectionStations: constant.toSelect(constant.inspectionStation),
        imageUrl: "",
        newRow: 0,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        materials: {
          pkid:0,
          sapMaterialId: 0,
          no: "",
          name: "",
          inspectionStandard: "",
          inspectionType: 10,
          itemDataType: 10,
          inspectionTools: "",
          standardValue: "",
          maxValue: "",
          minValue: "",
          unit: "",
          uploadPictures: "",
          inspectionMethod: 0,
          inspectionFrequency: "",
          inspectionPercentage: "",
          inspectionStation: "",
          note: "",
        },
        ruleValidate: {
          name: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error("上传头像图片只能是 JPG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },
      open(sapMaterialId,pkid) {
        this.materials.sapMaterialId = sapMaterialId;
        this.materials.pkid = pkid;
        this.dialogVisible = true;
        if(pkid>0) {
          this.getData();
        }else {
          this.getNode();
        }
      },
      getData() {
        this.$http
          .get("basic", `inspectionItems/${this.materials.pkid}`)
          .then(resp => {
            this.materials = resp;
          });
      },
      getNode() {
        this.$http
          .get("basic", "inspectionItems/selectNo")
          .then(resp => {
            this.materials.no = resp;
          });
      },
      handleSubmit() {
        if(this.materials.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "inspectionItems",  this.materials)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "inspectionItems/saveMaterialId", this.materials)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 380px;
    line-height: 380px;
    text-align: center;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }
</style>
